import { useTranslation } from 'react-i18next';

export default function useHeadingQuestion({ heading, content, unrequited }) {
    const { t }                    = useTranslation();
    const contentOrHeading         = (typeof heading !== 'undefined' && heading.trim()) ? heading : content;
    const optionalContentOrHeading = ` ${unrequited ? t('createRecord.option') : ''} ${contentOrHeading}`;
    return { contentOrHeading, optionalContentOrHeading, content, heading, t };
}
